// Tin mới sản phẩm — từ điển CHỦ ĐỀ (loại tin) dùng chung cho chuông, trang Tin mới, thẻ chat
// và trang soạn bài ở Core. MỘT nguồn: mã ở đây phải khớp CHECK `product_news.kind` của Core
// (backend/src/migrations/sql/2026-09-29_002_tin-moi-san-pham.sql) — thêm mã mới thì sửa cả hai.
//
// Nhãn khai bằng `msg` (MessageDescriptor) ⇒ ĐỌC QUA `kindMeta()`, đừng in trần `.label`
// (bản production strip message ⇒ React ném "Objects are not valid as a React child").
import { msg } from '@lingui/core/macro';
import { tMeta } from '../../i18n/runtime.js';

export const PRODUCT_NEWS_KINDS = {
  new: { label: msg`Tính năng mới`, chip: 'bg-violet-50 text-violet-700 border-violet-200', dot: 'bg-violet-500', icon: 'Sparkles' },
  improve: { label: msg`Cải tiến`, chip: 'bg-sky-50 text-sky-700 border-sky-200', dot: 'bg-sky-500', icon: 'TrendingUp' },
  fix: { label: msg`Sửa lỗi`, chip: 'bg-amber-50 text-amber-700 border-amber-200', dot: 'bg-amber-500', icon: 'Wrench' },
  notice: { label: msg`Thông báo`, chip: 'bg-slate-100 text-slate-700 border-slate-200', dot: 'bg-slate-500', icon: 'Megaphone' },
};

export const PRODUCT_NEWS_KIND_CODES = Object.keys(PRODUCT_NEWS_KINDS);

/** Cấu hình chủ đề đã dịch nhãn. Mã lạ (bản máy chủ mới hơn FE) rơi về «Thông báo». */
export function kindMeta(code) {
  return tMeta(PRODUCT_NEWS_KINDS[code] || PRODUCT_NEWS_KINDS.notice);
}
